import PropTypes from "prop-types";

import FormDialog from "components/modals/FormDialog";
import GroupForm from "routes/admin/components/GroupForm";

const GroupModal = ({ model, open, onOpenChange, onSuccess }) => (
  <FormDialog
    FormComponent={GroupForm}
    model={model}
    modelType="Group"
    open={open}
    onOpenChange={onOpenChange}
    onSuccess={onSuccess}
  />
);

GroupModal.propTypes = {
  model: PropTypes.object,
  open: PropTypes.bool,
  onOpenChange: PropTypes.func,
  onSuccess: PropTypes.func,
};

export default GroupModal;
